import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class ExternalStandIdentifierModel extends ApiModel {
  static get path() {
    return '/backend/external_stand_identifiers/{?id}';
  }

  @computed
  get standId() {
    return this.get('stand.id');
  }
}
